import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Row, Col, Container, Button } from 'reactstrap';
import './App.css';

class Home extends Component {
  constructor(args) {
    super(args);
    this.state = {
    };
  }
  
  componentDidMount () {
  }

  letsGo = () => {
    const {history} = this.props;
    history.push('/game');
  }
  
  render() {
    return (
        <Container>
        <Row>
          <Col>
            <h1>Virtuelle Ostereier</h1>
            <p>Meine Lieben, ich wünsche Euch Allen frohe und gesunde Ostern. Da wir Corona bedingt ja nicht alle zusammen sein können, dachte ich mir, wie lustig wäre eine virtuelle Ostereisuche.</p>
            <p>Nach etlichen Stunden der Programmierung (hat viel länger gedauert, als angedacht) und dank neuster künstlicher Intelligenz, können wir alle zusammen nach virtuellen, versteckten, Ostereier, suchen.</p>
            <p>Dazu stellt sicher, dass ihr mit einem WLAN verbunden seid (im Hintergrund laden große Dateien) und erlaubt dieser Webseite den Zugriff auf die Kamera Eures Smartphones (die Videos werden nicht gespeichert). Sobald alles geladen ist und ihr die Meldung bekommt, dass die Suche beginnen kann, könnt ihr mit Eurem Handy Eure Umgebung scannen und virtuell versteckte Eier suchen.</p>
            <p>Für jedes gefundene Ei gibt es 0,40€ an Gutscheinpunkten, für meine liebe Family, gutgeschrieben.</p>
            <p>Und nun wünsche ich Euch frohes Suchen.</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button onClick={() => {this.letsGo()}}>Ich will nun suchen</Button>
          </Col>
        </Row>
        
      </Container>
    );
  }
  
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/Home.js